module.exports = {"340503001":"沙塘路街道","340503002":"解放路街道","340503003":"湖东路街道","340503004":"桃源路街道","340503005":"霍里街道","340503006":"金家庄街道","340503007":"塘西街道","340503008":"慈湖街道","340503009":"江东街道","340503101":"濮塘镇","340503401":"慈湖高新技术产业开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340503.json
// module id = 986
// module chunks = 0